module.exports = __webpack_public_path__ + "img/off-icon.912d13f.png";